import { AvField, AvForm } from "availity-reactstrap-validation";
import { SuccessOk } from "configs/statusCode";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { Col, Row, Modal, ModalBody, ModalHeader, Label } from "reactstrap";
// const countryCodes = require("country-codes-list");
import { getCountryListMap } from "country-flags-dial-code";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "./styles.scss";

const EditClientModal = ({
	modal,
	Service,
	setShouldGetData,
	onCloseModal,
	form,
}) => {
	const service = new Service();
	const [loading, setLoading] = useState(false);
	const [formState, setFormState] = useState({});
	const [countriesCode, setCountriesCode] = useState([]);
	const [touched, setTouched] = useState(false);

	useEffect(() => {
		// const myCountryCodesObject = countryCodes.customList(
		//   "countryCode",
		//   "{countryNameEn}/{countryNameLocal} +{countryCallingCode}"
		// );
		// const entries = Object.entries(myCountryCodesObject);
		// setCountriesCode(
		//   entries?.map((c) => {
		//     return {
		//       label: c[1].split("+")[0],
		//       value: `+${c[1].split("+")[1]}`,
		//     };
		//   })
		// );

		const countrie = getCountryListMap();
		let x = Array.from(Object.values(countrie))?.map((res) => {
			return {
				value: `${res?.country} (${res?.dialCode})`,
				code: res?.dialCode,
				label: (
					<div style={{ display: "flex", alignItems: "center" }}>
						<img
							src={`data:image/svg+xml;utf8,${encodeURIComponent(res.flag)}`}
							alt={res?.dialCode}
							style={{ width: "20px", marginRight: "10px" }}
						/>
						{res?.country} ({res?.dialCode})
					</div>
				),
			};
		});

		setCountriesCode(x);
	}, []);

	useEffect(() => {
		setFormState({
			first_name: form.name.substring(0, form.name.indexOf(" ")),
			last_name: form.name.substring(form.name.indexOf(" ") + 1),
			user_name: form.user_name,
			email: form.email,
			phone: form.phone,
			// country_code: countriesCode?.find(res=> res?.code === form.country_code)
		});
	}, [countriesCode]);

	const handleValidSubmit = () => {
		// if(!formState?.country_code?.value){
		//     return
		// }
		if (!formState.phone) {
			setTouched(true);
			return;
		}
		setLoading(true);
		let data = {
			...formState,
		};
		service
			.updateClient(data, form.id)
			.then((res) => {
				if (res && res.status === SuccessOk) {
					toast.success("Cliect Update Successfully");
					setShouldGetData((prev) => !prev);
					onCloseModal("edit");
				} else {
					toast.error(res);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};
	const handleFieldChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
	};

	return (
		<Modal
			isOpen={modal}
			className="edit"
			toggle={() => onCloseModal("cancel")}
			style={{ maxWidth: "600px", marginTop: "6%", width: "100%" }}>
			<ModalHeader toggle={() => onCloseModal("cancel")}></ModalHeader>
			<ModalBody>
				<AvForm className="form-horizontal">
					<Row>
						<Col md={6} className="mb-3">
							<Label>First Name</Label>
							<AvField
								errorMessage="This field is required"
								className="font-size-14 d-block"
								name="first_name"
								bsSize="lg"
								required
								type="text"
								placeholder="First Name"
								value={formState.first_name}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<Label>Last Name</Label>
							<AvField
								errorMessage="This field is required"
								className="font-size-14 d-block"
								name="last_name"
								bsSize="lg"
								required
								type="text"
								placeholder="Last Name"
								value={formState.last_name}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<Label>User Name</Label>
							<AvField
								errorMessage="This field is required"
								className="font-size-14"
								name="user_name"
								bsSize="lg"
								required
								type="text"
								placeholder="User Name"
								value={formState.user_name}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<Label>Email</Label>
							<AvField
								errorMessage="This field is required"
								className="font-size-14"
								name="email"
								bsSize="lg"
								required
								type="email"
								placeholder="Email"
								value={formState.email}
								onChange={(e) => handleFieldChange(e)}
							/>
						</Col>
						<Col md={6}>
							<label className={touched ? "text-danger" : ""}>Phone</label>
							<PhoneInput
								country={"eg"}
								enableSearch={true}
								value={formState?.phone}
								onFocus={() => {
									setTouched(false);
								}}
								onBlur={() => {
									if (!formState?.phone) {
										setTouched(true);
									}
								}}
								onChange={(e) => {
									setTouched(false);
									setFormState({ ...formState, phone: e });
								}}
								inputStyle={{
									width: "100%",
									borderColor: touched ? "red" : "#ced4da",
								}}
							/>
							{touched && (
								<div
									className="text-danger"
									style={{ fontSize: "10px", marginTop: "4px" }}>
									This Field is required
								</div>
							)}
						</Col>
						{/* <Col md={6}className='mb-3'>
                            <Label>Phone</Label>
                            <AvField
                                errorMessage="This field is required"
                                className="font-size-14"
                                name="phone"
                                bsSize="lg"
                                required
                                type="number"
                                placeholder="Phone"
                                value={formState.phone}
                                onChange={(e) => handleFieldChange(e)}
                            />
                        </Col> */}
					</Row>

					<Row className="d-flex mt-3 justify-content-between ">
						<Col md={6} className="d-flex justify-content-end">
							<button
								onClick={() => onCloseModal("cancel")}
								className="btn btn-secondary  float-end btnHeight">
								Cancel
							</button>
						</Col>
						<Col md={6}>
							<button
								disabled={loading}
								type="submit"
								onClick={() => {
									if (!formState.phone) {
										setTouched(true);
									}
									handleValidSubmit();
								}}
								className="btn btn-success  btnHeight">
								Submit
							</button>
						</Col>
					</Row>
				</AvForm>
			</ModalBody>
		</Modal>
	);
};

export default EditClientModal;
